<script>
const MINUTE_IN_MILLI_SECONDS = 60000;
const HOUR_IN_MILLI_SECONDS = MINUTE_IN_MILLI_SECONDS * 60;
const DAY_IN_MILLI_SECONDS = HOUR_IN_MILLI_SECONDS * 24;

import { dynamicTime, dateFormat, mocGioNgay } from 'shared/helpers/timeHelper';

export default {
  name: 'TimeAgo',
  props: {
    isAutoRefreshEnabled: {
      type: Boolean,
      default: true,
    },
    lastActivityTimestamp: {
      type: [String, Date, Number],
      default: '',
    },
    createdAtTimestamp: {
      type: [String, Date, Number],
      default: '',
    },
    conversationId: {
      type: [String, Number],
      default: '',
    },
    // BonBoZ: keo moc "gio tao" ra khoi tooltip thanh mot huy hieu nhin thay
    // duoc. Chi bat khi danh sach dang loc theo ngay tao — luc do con so nay
    // giai thich vi sao hoi thoai lot vao ket qua.
    showCreatedAt: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lastActivityAtTimeAgo: dynamicTime(this.lastActivityTimestamp),
      createdAtTimeAgo: dynamicTime(this.createdAtTimestamp),
      timer: null,
    };
  },
  computed: {
    // BonBoZ: giờ phút cho hôm nay, "hôm qua" cho hôm qua, ngày tháng cho xa
    // hơn. Xem `mocGioNgay` trong timeHelper.js.
    lastActivityTime() {
      return mocGioNgay(this.lastActivityTimestamp);
    },
    createdAtTime() {
      return mocGioNgay(this.createdAtTimestamp);
    },
    createdAt() {
      const createdTimeDiff = Date.now() - this.createdAtTimestamp * 1000;
      const isBeforeAMonth = createdTimeDiff > DAY_IN_MILLI_SECONDS * 30;
      return !isBeforeAMonth
        ? `${this.$t('CHAT_LIST.CHAT_TIME_STAMP.CREATED.LATEST')} ${
            this.createdAtTimeAgo
          }`
        : `${this.$t('CHAT_LIST.CHAT_TIME_STAMP.CREATED.OLDEST')} ${dateFormat(
            this.createdAtTimestamp
          )}`;
    },
    lastActivity() {
      const lastActivityTimeDiff =
        Date.now() - this.lastActivityTimestamp * 1000;
      const isNotActive = lastActivityTimeDiff > DAY_IN_MILLI_SECONDS * 30;
      return !isNotActive
        ? `${this.$t('CHAT_LIST.CHAT_TIME_STAMP.LAST_ACTIVITY.ACTIVE')} ${
            this.lastActivityAtTimeAgo
          }`
        : `${this.$t(
            'CHAT_LIST.CHAT_TIME_STAMP.LAST_ACTIVITY.NOT_ACTIVE'
          )} ${dateFormat(this.lastActivityTimestamp)}`;
    },
    tooltipText() {
      // Hai dòng có NHÃN. Trước đây hai mốc dán cạnh nhau bằng một dấu chấm
      // tròn và không nhãn ("8 ngày trước • khoảng 17 giờ trước"), nên không
      // ai đoán được cái nào là ngày mở hội thoại, cái nào là tin cuối.
      return `${this.createdAt}
${this.lastActivity}`;
    },
  },
  watch: {
    lastActivityTimestamp() {
      this.lastActivityAtTimeAgo = dynamicTime(this.lastActivityTimestamp);
    },
    createdAtTimestamp() {
      this.createdAtTimeAgo = dynamicTime(this.createdAtTimestamp);
    },
    conversationId() {
      // Reset display values and timer when the row is recycled to a different conversation.
      this.lastActivityAtTimeAgo = dynamicTime(this.lastActivityTimestamp);
      this.createdAtTimeAgo = dynamicTime(this.createdAtTimestamp);
      if (this.isAutoRefreshEnabled) {
        clearTimeout(this.timer);
        this.createTimer();
      }
    },
  },
  mounted() {
    if (this.isAutoRefreshEnabled) {
      this.createTimer();
    }
  },
  unmounted() {
    clearTimeout(this.timer);
  },
  methods: {
    createTimer() {
      this.timer = setTimeout(() => {
        this.lastActivityAtTimeAgo = dynamicTime(this.lastActivityTimestamp);
        this.createdAtTimeAgo = dynamicTime(this.createdAtTimestamp);
        this.createTimer();
      }, this.refreshTime());
    },
    refreshTime() {
      const timeDiff = Date.now() - this.lastActivityTimestamp * 1000;
      if (timeDiff > DAY_IN_MILLI_SECONDS) {
        return DAY_IN_MILLI_SECONDS;
      }
      if (timeDiff > HOUR_IN_MILLI_SECONDS) {
        return HOUR_IN_MILLI_SECONDS;
      }

      return MINUTE_IN_MILLI_SECONDS;
    },
  },
};
</script>

<template>
  <div
    class="flex items-center gap-1 ml-auto leading-4 text-xxs text-n-slate-10 whitespace-nowrap"
  >
    <!-- Mốc luôn hiện: lần hội thoại có động tĩnh gần nhất. Đó là thứ danh sách
         đang sắp xếp theo, nên nó phải là con số nhìn thấy. Ngày mở hội thoại
         là bối cảnh — nằm trong tooltip cùng nhãn đầy đủ. -->
    <span
      v-tooltip.top="{
        content: tooltipText,
        delay: { show: 1000, hide: 0 },
      }"
      class="hover:text-n-slate-11"
    >
      {{ lastActivityTime }}
    </span>
    <!-- Cùng cách viết giờ với mốc bên cạnh: hôm nay thì giờ:phút, hôm qua thì
         thêm chữ "hôm qua", xa hơn thì ngày tháng. Hai kiểu viết khác nhau trên
         một dòng là bắt người đọc dịch qua lại. -->
    <span
      v-if="showCreatedAt"
      v-tooltip.top="$t('BONBOZ.LOC_NGAY.GIO_TAO')"
      class="bonboz-gio-tao px-1 rounded bg-n-blue-4 dark:bg-n-blue-5 text-n-blue-11"
    >
      {{ createdAtTime }}
    </span>
  </div>
</template>
